import React from 'react';

export default ({ id, className }) => <div className={className}>{id} deleted</div>;
